import { AxiosResponse } from "axios";
import { RestServiceConnection } from "../restServiceConnection";

const PROVIDERS_ENDPOINT = "/provider";

export class ProviderService extends RestServiceConnection {

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE PROVEEDORES
     * @EN GETS THE LIST OF PROVIDERS
     */
    // -------------------------------------------------------------------------------------------------------------
    listProviders = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PROVIDERS_ENDPOINT + "/list",
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE EL ULTIMO CODIGO DE PROVEEDOR
     * @EN GETS THE LAST PROVIDER CODE
     */
    // -------------------------------------------------------------------------------------------------------------
    getLastCode = async () => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PROVIDERS_ENDPOINT + "/get-last-code",
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE UN PROVEEEDOR POR SU ID
     * @EN GETS A PROVIDER BY ITS ID
     */
    // -------------------------------------------------------------------------------------------------------------
    getProvideById = async (providerId: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PROVIDERS_ENDPOINT + "/get",
            data: { id: providerId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES TOGGLEA UN PROVEEDOR
     * @EN TOGGLES A PROVIDER
     */
    // -------------------------------------------------------------------------------------------------------------
    toggleProviderStatus = async (providerId: string, status: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PROVIDERS_ENDPOINT + "/toggle",
            data: { id: providerId, statusId: status },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES CREA UN PROVEEDOR
     * @EN CREATES A PROVIDER
     */
    // -------------------------------------------------------------------------------------------------------------
    createProvider = async (provider: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PROVIDERS_ENDPOINT + "/create",
            data: provider,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES EDITA UN PROVEEDOR
     * @EN EDITS A PROVIDER
     */
    // -------------------------------------------------------------------------------------------------------------
    editProvider = async (provider: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PROVIDERS_ENDPOINT + "/edit",
            data: provider,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA UN PROVEEDOR
     * @EN DELETES A PROVIDER
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteProvider = async (providerId: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PROVIDERS_ENDPOINT + "/delete",
            data: { id: providerId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA VARIOS PROVEEDORES
     * @EN DELETES MULTIPLE PROVIDERS
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteMultiProvider = async (providerIds: string[]) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PROVIDERS_ENDPOINT + "/delete-multi",
            data: {
                ids: providerIds
            }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE PROVEEDORES PARA UN SELECT
     * @EN GETS THE LIST OF PROVIDERS FOR A SELECT
     */
    // -------------------------------------------------------------------------------------------------------------
    listForSelect = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PROVIDERS_ENDPOINT + "/list-select",
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES IMPORTA PROVEEDORES DESDE UN EXCEL
     * @EN IMPORTS PROVIDERS FROM AN EXCEL FILE
     */
    // -------------------------------------------------------------------------------------------------------------
    importExcel = async (formData: FormData) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PROVIDERS_ENDPOINT + "/import",
            data: formData,
            headers: { "Content-Type": "multipart/form-data" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA TODOS LOS PROVEEDORES
     * @EN DELETES ALL PROVIDERS
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteAllProviders = async (companyId?: string | null) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PROVIDERS_ENDPOINT + "/delete-all",
            data: companyId ? { company: companyId } : {},
            headers: { "Content-Type": "application/json" },
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------
}